import { Button, Drawer as DrawerAntd, DrawerProps } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';
import { NeutralColors } from 'theme';

const Drawer: FC<DrawerProps> = styled(DrawerAntd)`
  .fms-drawer-header-title {
    flex-direction: row-reverse;
  }

  .fms-drawer-close {
    margin-right: -10px;
  }

  .fms-drawer-body {
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  svg {
    width: 24px;
    height: 24px;
    padding: 4px;
    border-radius: 8px;
    cursor: pointer;

    :hover {
      border: 1px solid ${NeutralColors[20]};
    }
  }
`;

const ContainerChildren = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 16px;
  overflow: auto;
`;

const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  border-top: 1px solid ${NeutralColors[20]};
`;

const SaveButton = styled(Button)`
  margin-left: 16px;
`;

const ContainerSaveButton = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export {
  ContainerButtons,
  ContainerChildren,
  ContainerSaveButton,
  Drawer,
  HeaderContainer,
  SaveButton,
};
